import { render, staticRenderFns } from "./EchartTab.vue?vue&type=template&id=3193806c&scoped=true&"
import script from "./EchartTab.vue?vue&type=script&lang=js&"
export * from "./EchartTab.vue?vue&type=script&lang=js&"
import style0 from "./EchartTab.vue?vue&type=style&index=0&id=3193806c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3193806c",
  null
  
)

export default component.exports